export const ENDPOINT = process.env.REACT_APP_URL || 'https://fm1toipnv1.execute-api.us-west-2.amazonaws.com'
export const BUCKET = process.env.REACT_APP_GRAPHICS_BUCKET || 'prod-questionnaire-database-photosbucketb04725bc-1d7z4qt4fi8l3'
